/** @jsxImportSource @emotion/react */

import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTypedSelector } from '@hook/common/useStore';
import PageTemplate from '@page/iyagigo/page-template';
import { INVALID_URL } from '@constant/error';
import { EVocabularyBookStudyType, TIyagigoSubMenu } from '@datatype/iyagigo/type';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';
import VocabularyBookNote from '@component/iyagigo/vocabulary-book/vocabulary-book-note';

const VocabularyBookNotePage: React.FC = () => {
  // ############### route ###############
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const languagePath = searchParams.get('language');
  const subjectPath = searchParams.get('subject') as TIyagigoSubMenu['vocabulary-book'];
  if (!languagePath && !subjectPath) throw new Error(INVALID_URL);

  // ############### state ###############
  const vocabularyBookStudyType =
    useTypedSelector((state) => state.rootReducer?.vocabularyBookReducer?.vocabularyBookStudyType) ??
    EVocabularyBookStudyType.BOOKMARK_NOTE;

  return (
    <PageTemplate
      title={vocabularyBookStudyType === EVocabularyBookStudyType.INCORRECT_NOTE ? '틀린 단어' : '저장한 단어'}
      mode='back'
      handleNavigationClick={() => navigate(IYAGIGO_PATH.VOCABULARY_BOOK_HOME_PATH)}>
      <VocabularyBookNote />
    </PageTemplate>
  );
};

export default VocabularyBookNotePage;
